import { Box } from "@mui/material";
import { GridColumns } from "@mui/x-data-grid";
import dayjs from "dayjs";
import { get } from "lodash";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { CustomLink } from "styles/global.style";
import { numberFormat } from "utils/numberFormat";

export const useStudentsColumns = (): GridColumns<any> => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return [
    // {
    //   field: t("TABLE.ID"),
    //   renderCell(params) {
    //     return get(params, "row.uuid");
    //   },
    //   flex: 0.5,
    // },
    {
      field: t("general.image"),
      headerName: t("general.image")!,
      renderCell: (params) => {
        const imageUrl = params.row.imageUrl 
          ? `${process.env.REACT_APP_BASE_URL}${params.row.imageUrl}` 
          : null;
    
        return imageUrl ? (
          <img
            src={imageUrl}
            alt="Product"
            style={{ width: 40, height: 40, objectFit: "cover", borderRadius: 50 }}
          />
        ) : (
          ""
        );
      }
    },
    {
      field: "contractNumber",
      headerName: t("TABLE.CONTRACT_NUMBER")!,
      sortable: true,
      renderCell(params) {
        return get(params, "row.contractNumber");
      },
      width: 180,
    },
    {
      field: "lastName",
      headerName: t("TABLE.FIO")!,
      sortable: true,
      renderCell(params) {
        return (
          <CustomLink
            onClick={() => navigate(`/students/info/${get(params, "row._id")}`)}
          >
            {get(params, "row.lastName", " ") +
              " " +
              get(params, "row.firstName", " ")}
          </CustomLink>
        );
      },
      width: 220,
    },
    {
      field: t("TABLE.CLASS"),
      renderCell(params) {
        return (
          <span>
            {get(params, "row.class.grade", "") +
              "-" +
              get(params, "row.class.letter", " ") +
              " " + get(params, "row.class.name", " ")}
          </span>
        );
      },
      width: 60,
    },

    {
      field: t("TABLE.PHONE_NUMBER"),
      renderCell(params) {
        return get(params, "row.phoneNumber", " ");
      },
      width: 120,
    },
    {
      field: t("TABLE.HEAD_TEACHER"),
      renderCell(params) {
        return (
          <Box sx={{ display: "flex", gap: "6px", flexWrap: "wrap" }}>
            {get(params, "row.class.headTeacher", [])?.map(
              (teacher: Record<string, any>) => (
                <CustomLink
                  onClick={() =>
                    navigate(`/employees/info/${get(teacher, "_id", "")}`)
                  }
                >
                  {get(teacher, "firstName", "") +
                    " " +
                    get(teacher, "lastName", "")}
                </CustomLink>
              )
            )}
          </Box>
        );
      },
      width: 220,
    },
    {
      field: "archivenDate",
      headerName: t("general.archive_date")!,
      sortable: true,
      renderCell(params) {
        return dayjs(params?.row?.archivenDate).format("DD.MM.YYYY | HH:mm");
      },
      width: 180,
    },
    
  ];
};
